namespace GeniuzPOS.InitialData {
    export interface PsCashCouponTypeRow {
        Id?: number;
        CashCouponType?: string;
        CashCouponName?: string;
        CashCouponValueType?: number;
        CashCouponValue?: number;
        PartnerCompensateAmt?: number;
        PartnerCompensatePc?: number;
        ProdImageLink?: string;
        StartDate?: string;
        EndDate?: string;
        IsActive?: number;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace PsCashCouponTypeRow {
        export const idProperty = 'CashCouponType';
        export const nameProperty = 'CashCouponName';
        export const localTextPrefix = 'InitialData.PsCashCouponType';
        export const lookupKey = 'InitialData.PsCashCouponType';

        export function getLookup(): Q.Lookup<PsCashCouponTypeRow> {
            return Q.getLookup<PsCashCouponTypeRow>('InitialData.PsCashCouponType');
        }
        export const deletePermission = '1POSBASE:ข้อมูลอ้างอิง:ประเภทการรับเงิน,คูปอง:ประเภทคูปองเงินสด:Delete';
        export const insertPermission = '1POSBASE:ข้อมูลอ้างอิง:ประเภทการรับเงิน,คูปอง:ประเภทคูปองเงินสด:Modify';
        export const readPermission = '1POSBASE:ข้อมูลอ้างอิง:ประเภทการรับเงิน,คูปอง:ประเภทคูปองเงินสด:View';
        export const updatePermission = '1POSBASE:ข้อมูลอ้างอิง:ประเภทการรับเงิน,คูปอง:ประเภทคูปองเงินสด:Modify';

        export declare const enum Fields {
            Id = "Id",
            CashCouponType = "CashCouponType",
            CashCouponName = "CashCouponName",
            CashCouponValueType = "CashCouponValueType",
            CashCouponValue = "CashCouponValue",
            PartnerCompensateAmt = "PartnerCompensateAmt",
            PartnerCompensatePc = "PartnerCompensatePc",
            ProdImageLink = "ProdImageLink",
            StartDate = "StartDate",
            EndDate = "EndDate",
            IsActive = "IsActive",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
